import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent  {

  constructor() { 
    console.log(' constructor')
  }


}
